export const OFF_PATHS = 'hors_chemins';
export const PATHS = 'chemins';

export default PATHS;



// WEBPACK FOOTER //
// ./src/helpers/mapFiltersHelpers.js